import { format, startOfDay, endOfDay } from 'date-fns';
import moment from 'moment';
import { colors } from '../constants/colors';
import { ZSTDDecoder } from "zstddec";
import { strFromU8 } from "fflate";
import { FaCamera } from 'react-icons/fa';
import { TransformedSegment } from './types';
import axios from 'axios';
import dayjs from 'dayjs';

export const methods = {
  post: 'POST',
  get: 'GET',
  put: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE',
};

export const formatDateTimeRange = (inputDate: any) => {
  const date = new Date(inputDate);
  const startDate = startOfDay(date);
  const endDate = endOfDay(date);

  return {
    start_datetime: format(startDate, 'yyyy-MM-dd HH:mm'),
    end_datetime: format(endDate, 'yyyy-MM-dd HH:mm'),
  };
};

export const getFormattedDate = (date: string | any) => {
  return dayjs(date).format("YYYY-MM-DD");
};

export const generateGapTimeData = (data: any[]) => {
  const startTime = new Date(data[0].gps_time).getTime() / 1000;
  return data.map((point: any) => {
    const currentTime = new Date(point.gps_time).getTime() / 1000;
    const gapTimeInSec = currentTime - startTime;
    return { ...point, gapTimeInSec };
  });
};



// export const constructVideoListUrl = (deviceId: string, startTime: string, endTime: string): string => {
//   return `/api/video-list-test/?deviceId=${deviceId}&start_datetime=${startTime}&end_datetime=${endTime}`;
// };

// export const constructCoordinateUrl = (deviceId: string, startTime: string, endTime: string): string => {
//   return `api/device-trip-statistics/?deviceId=${deviceId}&start_datetime=${startTime}&end_datetime=${endTime}`;
// };

// export const constGetKmUrl = (deviceId: string, startTime: string, endTime: string): string => {
//   return `/api/get-km/?deviceId=${deviceId}&start_datetime=${startTime}&end_datetime=${endTime}`;
// };

export const rotateImage = (imgUrl: any, degrees: any, callback: any) => {
  const img = new Image();
  img.src = imgUrl;
  img.onload = () => {
    const canvas = document.createElement('canvas');
    const ctx: any = canvas.getContext('2d');
    const size: any = Math.max(img.width, img.height);
    canvas.width = size;
    canvas.height = size;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();
    ctx.translate(size / 2, size / 2);
    ctx.rotate((degrees * Math.PI) / 180);
    ctx.drawImage(img, -img.width / 2, -img.height / 2);
    ctx.restore();
    callback(canvas.toDataURL());
  };
};

export const newDashboardTableHeader = (editCB: any, deleteCB: any, viewCB: any) => {
  return [
    {
      headerName: "Group Name",
      flex: 1,
      field: "group_name",
      sortable: true,
    },
    {
      headerName: "No of Vehicles",
      flex: 1,
      field: "device_access_length",
      sortable: true,
    },
    {
      headerName: "Created Date",
      flex: 1,
      field: "created_at",
      sortable: true,
    },
    {
      headerName: "Updated Date",
      flex: 1,
      field: "updated_at",
      sortable: true,
    },
    {
      headerName: "Actions",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              editCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#007BFF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/edit.png"
              alt="Edit"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              deleteCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/delete.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
        </div>
      ),
    },
  ];
};

export const subGroupHeader = (viewCB: any) => {
  return [
    {
      headerName: "Driver Name",
      flex: 1,
      field: "driver_name",
      sortable: true,
    },
    {
      headerName: "Device Name",
      flex: 1,
      field: "device_name",
      sortable: true,
    },
    {
      headerName: "Plate Number",
      flex: 1,
      field: "plateno",
      sortable: true,
    },
    {
      headerName: "Device IMEI",
      flex: 1,
      field: "device_imei",
      sortable: true,
    },
    {
      headerName: "Last Online Time",
      flex: 1,
      field: "lastonlinetime",
      sortable: true,
    },
    {
      headerName: "Created on",
      flex: 1,
      field: "created_on",
      sortable: true,
    },
    {
      headerName: "Actions",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
        </div>

      ),
    },
  ];
};

export const userTableData = (viewCB: any) => {
  return [
    {
      headerName: "Vehicle No",
      flex: 1,
      field: "devicename",
      sortable: true,
    },
    {
      headerName: "Driver Name",
      flex: 1,
      field: "driver_name",
      sortable: true,
    },
    {
      headerName: "Distance",
      flex: 1,
      field: "distance_km",
      sortable: true,
    },
    {
      headerName: "Duration",
      flex: 1,
      field: "duration",
      sortable: true,
    },
    {
      headerName: "Start Time",
      flex: 1,
      field: "trip_start_time",
      sortable: true,
    },
    {
      headerName: "End Time",
      flex: 1,
      field: "trip_end_time",
      sortable: true,
    },
    {
      headerName: "Actions",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
        </div>

      ),
    },
  ];
};


export const alarmHeaderData = (viewCB: any, playCB: any) => {
  return [
    {
      headerName: "Vehicle No",
      flex: 1,
      field: "deviceName",
      sortable: true,
    },
    {
      headerName: "Alarm Type",
      flex: 1,
      field: "alarm_type_value",
      sortable: true,
    },
    {
      headerName: "GPS Time",
      flex: 1,
      field: "gps_time",
      sortable: true,
    },
    {
      headerName: "Location",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>

        </div>

      ),
    },
  ];
};


export const driverTableHeader = (editCB: any, deleteCB: any, viewCB: any) => {
  return [
    {
      headerName: "Name",
      flex: 1,
      field: "driver_name",
      sortable: true,
    },
    {
      headerName: "Mobile Number",
      flex: 1,
      field: "contact_no",
      sortable: true,
    },
    {
      headerName: "License",
      flex: 1,
      field: "driving_licence",
      sortable: true,
    },
    {
      headerName: "Aadhar Card",
      flex: 1,
      field: "aadhar_no",
      sortable: true,
    },
    {
      headerName: "Created on",
      flex: 1,
      field: "created_on",
      sortable: true,
    },
    {
      headerName: "Actions",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              editCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#007BFF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/edit.png"
              alt="Edit"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              deleteCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/delete.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
        </div>
      ),
    },
  ];
};

export const userTableHeader = (editCB: any, deleteCB: any, viewCB: any) => {
  return [
    {
      headerName: "ID",
      flex: 1,
      field: "id",
      sortable: true,
    },
    {
      headerName: "User Name",
      flex: 1,
      field: "name",
      sortable: true,
    },
    {
      headerName: "Mobile Number",
      flex: 1,
      field: "phoneno",
      sortable: true,
    },
    {
      headerName: "Status",
      flex: 1,
      field: "is_active",
      sortable: true,
    },
    {
      headerName: "Created on",
      flex: 1,
      field: "created_at",
      sortable: true,
    },
    {
      headerName: "Updated on",
      flex: 1,
      field: "updated_at",
      sortable: true,
    },
    {
      headerName: "Actions",
      type: "list",
      flex: 1,
      field: "actions",
      sortable: false,
      renderCell: (params: any) => (
        <div style={{ display: 'flex', gap: '3px', alignItems: 'center', justifyContent: 'flex-end' }}>
          <p
            onClick={(_) => {
              editCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#007BFF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/edit.png"
              alt="Edit"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              deleteCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/delete.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
          <p
            onClick={(_) => {
              viewCB(params.row);
            }}
            style={{
              textDecoration: 'underline',
              fontWeight: 'bold',
              color: '#1E3A8A',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src="/assets/icons/view.png"
              alt="Delete"
              style={{ width: '20px', height: '20px', marginRight: '5px' }}
            />
          </p>
        </div>

      ),
    },
  ];
};



export const formatISTDate = (date: any) => {
  const getDate = moment(date).subtract(5, 'hours').subtract(30, 'minutes');
  return getDate.toISOString()
}

export const getColor = (spdThres: any) => {
  switch (spdThres) {
    case 'L':
      return colors.green;
    case 'H':
      return colors.red;
    case 'M':
    default:
      return colors.orange;
  }
};

export const transformPlans = (plans = []) => {
  const formattedPlans: Record<string, any> = {};
  if (!Array.isArray(plans)) return formattedPlans;
  plans.forEach((plan: any) => {
    const key = plan.plan_name.replace(/\s+(\w)/g, (_: any, c: any) => c.toUpperCase()).replace(/^./, (c: any) => c.toLowerCase());
    formattedPlans[key] = [
      {
        id: plan?.id,
        title: plan.plan_name,
        originalPrice: plan.price,
        price: `₹${plan.price}/mo`,
        liveHours: `${plan.live_video_stream_duration} Hours`,
        playbackHours: `${plan.playback_video_stream_duration} Hours`,
        intercomHours: `${plan.total_video_stream_duration - (plan.live_video_stream_duration + plan.playback_video_stream_duration)} Hours`,
        description: plan.plan_description,
        features: [
          `Vehicle Type: ${plan.vehicle_type}`,
          `Security Deposit: ${plan.security_deposit}`,
          `Sale Dashcam: ${plan.sale_dashcam}`,
          `Route: ${plan.route}`,
          `People Counting: ${plan.people_counting ? "Yes" : "No"}`,
          `Pilferage Detection: ${plan.pilferage_detection ? "Yes" : "No"}`,
          `Plan Features: ${plan.plan_features.features}`,
          `Application Process: ${plan.plan_features.application_process}`,
          `GPS: ${plan.plan_features.gps ? "Yes" : "No"}`,
          `Voice Calling: ${plan.plan_features.voice_calling ? "Yes" : "No"}`,
        ],
        icon: <FaCamera size={30} />,
      },
    ];
  });

  return formattedPlans;
};



export const convertToSegments = (testData: any[][]): { start: number; end: number }[][] => {
  return testData.map((cameraSegments) => {
    if (!cameraSegments || cameraSegments.length === 0) return [];

    const referenceDay = moment(cameraSegments[0].start_time).startOf('day');

    return cameraSegments.map((segment) => {
      const startSec = moment(segment.start_time).diff(referenceDay, 'seconds');
      const endSec = moment(segment.end_time).diff(referenceDay, 'seconds');
      return { start: startSec, end: endSec };
    });
  });
};



export const transformData = (
  data: any,
  timeToSeconds: (gpsTime: string, isUTC: boolean, firstTime?: string) => number
): TransformedSegment[][] =>
  data.response.map((trip: any) => {
    const { coordinates } = trip;
    const firstTime = coordinates[0]?.gps_time;

    const tripResult = new Array<TransformedSegment>(coordinates.length);
    for (let j = 0; j < coordinates.length; j++) {
      const segment: any = coordinates[j];
      tripResult[j] = {
        direction: segment?.direction,
        spd_thres: segment?.spd_thres,
        spd: segment?.spd,
        status: segment?.status,
        gps_time: segment?.gps_time,
        lat: segment?.latitude,
        lng: segment?.longitude,
        seconds: timeToSeconds(segment?.gps_time, true, firstTime),
        url: segment.url
      };
    }
    return tripResult;
  });



export const filterPathPoints = (points: { lat: number; lng: number }[]) => {
  const MAX_JUMP_DISTANCE = 200; // meters

  const haversineDistance = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    const toRad = (value: number) => value * Math.PI / 180;
    const R = 6371e3; // meters
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  const filtered: typeof points = [];
  let last: { lat: number; lng: number } | null = null;

  for (const point of points) {
    if (!point?.lat || !point?.lng) continue;

    if (!last) {
      filtered.push(point);
      last = point;
    } else {
      const distance = haversineDistance(last.lat, last.lng, point.lat, point.lng);
      if (distance < MAX_JUMP_DISTANCE) {
        filtered.push(point);
        last = point;
      }
    }
  }

  return filtered;
};


export const fileDecoder = async (responsesFile: any) => {
  if (typeof (responsesFile) == 'string') {
    const fileUrl = responsesFile;
    const fileRes = await axios.get(fileUrl, { responseType: "arraybuffer" });
    const uint8Array = new Uint8Array(fileRes.data);
    const decoder = new ZSTDDecoder();
    await decoder.init();
    const decompressedData = decoder.decode(uint8Array);
    const jsonString = strFromU8(decompressedData);
    return JSON.parse(jsonString);
  }
}

export const mapDeviceToVehicle = (device: any) => {
  return {
    devicename: device.device_name || device.system_id,
    deviceno: device.system_id,
    status: device.is_online ? "online" : "offline",
    raw: device,
  };
};

export const groupDevicesByCity = (
  devices: any[],
  cityName = "Delhi"
) => {
  const fleet_devices = devices.map(mapDeviceToVehicle);

  return {
    [cityName]: {
      fleet_devices,
    },
  };
};

export const calculateDeviceCounts = (devices: any[]) => {
  let total_online = 0;
  let total_offline = 0;
  devices.forEach((d) => {
    if (d.is_online) total_online++;
    else total_offline++;
  });
  return { total_online, total_offline };
};

export const formatFleetData = (
  apiResponse: any[],
  cityName = "Delhi"
) => {
  if (!Array.isArray(apiResponse)) {
    return {
      total_online: 0,
      total_offline: 0,
    };
  }
  const counts = calculateDeviceCounts(apiResponse);
  const grouped = groupDevicesByCity(apiResponse, cityName);
  return {
    ...counts,
    ...grouped,
  };
};

export const getOfflineTime = (utcTime: any) => {
  if (!utcTime) return ["Offline", "0 Min"];
  const lastSeen = new Date(utcTime).getTime();
  const now = new Date().getTime();
  const diffMs = now - lastSeen;
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  if (diffHours > 0) {
    return [`${diffHours} Hour${diffHours > 1 ? "s" : ""}`];
  } else {
    return [`${diffMinutes} Min`];
  }
};

export const formatCount = (num: number) => {
  if (num >= 10000000) {
    return `${(num / 10000000).toFixed(1).replace(".0", "")}Cr`;
  }

  if (num >= 100000) {
    return `${(num / 100000).toFixed(1).replace(".0", "")}L`;
  }

  if (num >= 1000) {
    return `${(num / 1000).toFixed(1).replace(".0", "")}K`;
  }

  return num.toString();
};